const GHOST_URL = import.meta.env.VITE_GHOST_URL
const GHOST_KEY = import.meta.env.VITE_GHOST_KEY

export interface GhostTag {
	id: string
	name: string
	slug: string
}

export interface GhostPost {
	id: string
	title: string
	slug: string
	excerpt: string
	custom_excerpt: string | null
	feature_image: string | null
	feature_image_alt: string | null
	published_at: string
	reading_time: number
	tags: GhostTag[]
	url: string
}

interface GhostPostsResponse {
	posts: GhostPost[]
	meta: {
		pagination: {
			page: number
			limit: number
			pages: number
			total: number
		}
	}
}

export async function fetchPosts(limit = 3): Promise<GhostPost[]> {
	if (!GHOST_KEY) {
		throw new Error('Ghost API key not configured. See VITE_GHOST_KEY in .env.example')
	}
	const url = `${GHOST_URL}/ghost/api/content/posts/?key=${GHOST_KEY}&limit=${limit}&fields=id,title,slug,excerpt,published_at,feature_image,url&order=published_at+desc`
	const res = await fetch(url)
	if (!res.ok) {
		throw new Error(`Ghost API error: ${res.status}`)
	}
	const data: GhostPostsResponse = await res.json()
	return data?.posts ?? []
}

export async function fetchProjects(): Promise<GhostPost[]> {
	const url = `${GHOST_URL}/ghost/api/content/posts/?key=${GHOST_KEY}&filter=tag:projects&include=tags&limit=all&order=published_at%20desc`
	const res = await fetch(url)
	if (!res.ok) {
		throw new Error(`Ghost API error: ${res.status}`)
	}
	const data: GhostPostsResponse = await res.json()
	return data?.posts ?? []
}
